// src\app\app-routing.module.ts
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

/* =====================================================
 * AUTH GUARD (ÁREA LOGADA)
 * -----------------------------------------------------
 * Protege a área /tabs para evitar:
 * - Tabs carregarem sem usuário (cold start / F5)
 * - ProgressTrackerService ser chamado sem uid
 * - inconsistência comum no Emulator (Auth ok, doc Firestore ausente)
 * ===================================================== */
import { AuthGuard } from '@core/guards/auth.guard';

const routes: Routes = [

  // ===============================
  // REGISTRO (ROTAS PÚBLICAS)
  // ===============================
  {
    path: 'registration',
    loadChildren: () =>
      import('./modules/registration/registration.module')
        .then(m => m.RegistrationModule),
  },

  // ===============================
  // ÁREA COM TABS (ÁREA LOGADA)
  // ===============================
  {
    path: 'tabs',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/profile/profile.module').then(m => m.ProfileModule),
  },

  // ===============================
  // ASSINATURA (FORA DAS TABS)
  // ===============================
  {
    path: 'subscription',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/subscription/subscription.module')
        .then(m => m.SubscriptionModule),
  },

  // ===============================
  // AVALIAÇÃO
  // ===============================
  {
    path: 'evaluation',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/evaluation/evaluation.module')
        .then(m => m.EvaluationModule),
  },
  // ===============================
  // TELAS FORA DAS TABS
  // ===============================
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/profile/components/settings/settings.module')
        .then(m => m.SettingsModule),
  },
  {
    path: 'email-change',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/profile/components/email-change-profile/email-change-profile.module')
        .then(m => m.EmailChangeProfileModule),
  },
  {
    path: 'email-change-confirm',
    loadChildren: () =>
      import('./modules/profile/components/email-change-confirm/email-change-confirm.module')
        .then(m => m.EmailChangeConfirmModule),
  },
  {
    path: 'edit-profile',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/profile/components/edit-profile/edit-profile.module')
        .then(m => m.EditProfileModule),
  },
  {
    path: 'plan',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/profile/components/plan/plan.module')
        .then(m => m.PlanModule),
  },

  // ===============================
  // REDIRECIONAMENTO PADRÃO
  // ===============================
  {
    path: '',
    // =====================================================
    // MELHOR PRÁTICA (BOOTSTRAP/COLD START)
    // -----------------------------------------------------
    // Evita tentar entrar em /tabs no cold start quando não há
    // usuário autenticado (reduz flash/erros e telas intermediárias).
    // O AuthGuard seguirá protegendo /tabs quando acessado diretamente.
    // =====================================================
    redirectTo: 'registration/signin',
    pathMatch: 'full',
  },

  {
    path: '**',
    // =====================================================
    // MELHOR PRÁTICA (FALLBACK GLOBAL)
    // -----------------------------------------------------
    // Mantém o fallback em rota pública, evitando cair em /tabs
    // sem autenticação em cenários de rota inválida.
    // =====================================================
    redirectTo: 'registration/signin',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
